type ExtendableClass = { prototype: {} }

/**
 * Combines methods from multiple classes at run time for pseudo multi-class inheritance. Static properties defined on a base
 * class (i.e. foo: string = 'Foo') do not work, since its constructor is never called (use getterssetter instead). Also, common
 * preperties that will need to be accessed by multiple merged classes can only be defined in one place. Do this, the extend the
 * other class interfaces to make typescript happy again.
 * @param extendedClass The class that will receive new methods from all base classes
 * @param baseClasses One or more classes to merge, in order, copying methods/getters/setters over if not already defined
 */
export function extendClass(extendedClass: ExtendableClass, ...baseClasses: ExtendableClass[]): void {
  baseClasses.forEach(baseClass => {
    Object.getOwnPropertyNames(baseClass.prototype).forEach(name => {
      if (extendedClass.hasOwnProperty(name)) return
      if (extendedClass.prototype.hasOwnProperty(name)) return
      Object.defineProperty(extendedClass.prototype, name, Object.getOwnPropertyDescriptor(baseClass.prototype, name))
    })
  })
}
